import { Dispatch, FC, SetStateAction } from 'react';

import { SwitchComponent } from '@/components/UI/Switch/Switch';

import styles from './ToggleAddSearchResult.module.css';

type ToggleAddSearchResultProps = {
  addSearchResults: boolean;
  setAddSearchResults: Dispatch<SetStateAction<boolean>> | ((checked: boolean) => void);
};
const ToggleAddSearchResult: FC<ToggleAddSearchResultProps> = ({ addSearchResults, setAddSearchResults }) => {
  return (
    <div className={styles.directToevoegenDiv}>
      <div className={styles.directToevoegenLabel}>Direct toevoegen&nbsp;</div>
      <div style={{ cursor: 'pointer', lineHeight: '24px' }}>
        <SwitchComponent
          data-testid='addSearchResultsSwitch'
          defaultValue={addSearchResults}
          onChange={setAddSearchResults}
        />
      </div>
    </div>
  );
};
export default ToggleAddSearchResult;
